import React, { useEffect } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const DataTerms1 = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className={styles["count-group"]}>
					<p>전송요구 및 정보 제공 동의</p>
					<div><span>3</span>/3</div>
				</div>
				<div className={`${styles["terms-area"]} mt_40 pb_100`}>
					<p>가입상품 목록 전송요구 및 개인(신용) 정보 수집 ・ 이용 동의서(목록정보전송)</p>
					<span className="mt_10">
						핀테크는 ⌜신용정보의 이용 및 보호에 관한 법률⌟, ⌜개인정보 보호법⌟등 관련 법령에 따라 다음과 같이 귀하의 개인(신용)정보를 처리합니다.
					</span>
					<ul className="mt_40">
						<li>
							<div>거부 권리 및 불이익</div>
							<span>
								귀하는 개인(신용)정보 수집 ・ 이용에 관한 동의를 거부 하실 수 있습니다. 다만, “수집 ・ 이용에 관한 동의”는 본인신용 정보 통합조회, 데이터분석 서비스의 이용을 위한 필수적 사항이므로 동의를 거부할 경우 본인신용정보 통합조회, 데이터분석 서비스의 이용이 제한될 수 있습니다.
							</span>
						</li>
						<li>
							<div>정보제공자</div>
							<span>
								[정보제공자명] KB국민은행, 신한카드, 기업은행, 광주은행, 키움증권, 페이코, 삼성화재, 메리츠화재, 한국투자증권, SC제일은행
							</span>
						</li>
						<li>
							<div>개인(신용)정보를 제공받는자</div>
							<span>핀테크</span>
						</li>
						<li>
							<div>전송요구 및 수집 ・ 이용 목적</div>
							<span>상세정보 전송요구를 위한 가입상품 목록 조회</span>
						</li>
						<li>
							<div>전송요구 종료시점, 보유 및 이용기간</div>
							<p className="text-blue mt_10">상세정보 전송요구 시까지 또는 7일 중 짧은 기간</p>
						</li>
						<li>
							<div>전송을 요구하는 개인(신용)정보(수집 ・ 이용 항목)</div>
							<div className={styles.category}>
								<div>
									<p>개인(식별)정보</p>
									<span>・ 전자서명, 접근토큰, 인증서, 전송요구서</span>
								</div>
							</div>
							<div className={styles.category}>
								<div>
									<p>개인(신용)거래정보</p>
									<div className="pl_10">
										<div>
											<div>은행</div>
											<span>
												・ 계좌(수신상품/투자상품/대출상품)목록 : 고객 정보 최초 생성일, 계좌번호, 회차번호, 상품명, 마이너스약정여부, 외화계좌여부, 계좌구분, 계좌상태, 적요<br />
												・ 개인형IRP 계좌 목록 : 상품명, 계좌번호
											</span>
										</div>
										<div className="mt_5">
											<div>전자금융</div>
											<span>
												・ 선불전자지급수단 목록 : 권면 ID, 권면명, 권면한도, 자동충전 등록여부, 통화코드, 계정 식별값<br />
												・ 계정 목록 : subkey, 계정 식별값, 가입일, 결제수단 등록여부
											</span>
										</div>
										<div className="mt_5">
											<div>P2P</div>
											<span>
												・ P2P 대출 목록 : 대출계약번호, 상품유형, 대출계약금액, 대출일
											</span>
										</div>
									</div>
								</div>
							</div>
						</li>
					</ul>
					<p className="mt_30">위와 같은 전송요구 및 개인(신용)정보 수집 ・ 이용에 동의하십니까?</p>
				</div>
			</div>
			{/* 스크롤 끝 까지 내려가면 가이드 텍스트 사라지고 버튼명 동의하기로 변경 */}
			<div className={`${styles["floating-btn"]} padding`}>
				<div className="flex-justify_center mb_20">
					<span className={styles.guide}><i className="icon icon_floating_arrow_down mr_5" />끝까지 확인하고 동의하기</span>
				</div>
				<Button className="btn btn--big">아래로 내려보기</Button>
			</div>
		</div>
	)
}

export default DataTerms1